// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__LsRqo","rootSuccess":"CompleteLink_rootSuccess__3IFEg","rootFailure":"CompleteLink_rootFailure__2Indd","isDisabled":"CompleteLink_isDisabled__2Z3Y-"};